
import { Layout, Space, Card, message, List, Spin, Button, Modal, Typography } from 'antd';
import Search from 'antd/es/input/Search';
import { ReloadOutlined, CheckCircleOutlined, CloseCircleOutlined, QrcodeOutlined, SearchOutlined } from '@ant-design/icons';
import request from '../utils/request';
import ShopInfo from '../components/ShopInfo/ShopInfo';
import "./Myshop.css"
import { useEffect, useRef, useState } from 'react';
import { useAtom } from 'jotai';
import { loggedInUserAtom, storesAtom } from '../store/userAtom';
import { useLocation, useNavigate } from 'react-router-dom';
import "./ShopTwoDetails.css"


const { Header } = Layout;
const headerStyle = {
  textAlign: 'center',
  color: '#fff',
  height: 64,
  paddingInline: 48,
  lineHeight: '64px',
  backgroundColor: '#ED4948',
};
const contentStyle = {
  padding: '24px',
  width: '100%',
  boxSizing: 'border-box',

}

const { Title } = Typography;

const MyShopTwo = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const { code } = location.state || {};
  const [productData, setProductData] = useState({});
  const [messageApi, contextHolder] = message.useMessage();
  const [stores, setStores] = useAtom(storesAtom);

  useEffect(() => {
    if (!code) {
      messageApi.error("没有找到商品编码");
      navigate('/');
      return;
    }

    // 初始化每个店铺的加载状态
    const initialProductData = {};
    (stores || []).forEach(store => {
      initialProductData[store.store_id] = {
        storeId: store.store_id,
        storeName: store.store_name,
        loading: true,
        data: null,
        error: null
      };
    });
    setProductData(initialProductData);

    const fetchData = () => {
      (stores || []).forEach(store => {
        // 使用项目封装的request.js发送请求
        const targetUrl = `${store.address}/get_articulo?code=${code}`;
        request.get('/proxy', {
          params: {
            address: encodeURIComponent(targetUrl)
          }
        })
          .then(response => {
            const data = response.data;
            setProductData(prev => ({
              ...prev,
              [store.store_id]: {
                ...prev[store.store_id],
                loading: false,
                data: data,
                error: null
              }
            }));
          })
          .catch(error => {
            console.error(`获取店铺 ${store.store_name} 商品信息失败:`, error);
            setProductData(prev => ({
              ...prev,
              [store.store_id]: {
                ...prev[store.store_id],
                loading: false,
                data: null,
                error: error
              }
            }));
          });
      });
    };

    fetchData();
  }, [code, navigate, messageApi, stores]);

  const handleBack = () => {
    navigate(-1);
  };

  // 格式化数字为两位小数
  const formatNumber = (num) => {
    if (!num) return '0.00';
    return parseFloat(num).toFixed(2);
  };


  const checkAllStoresHealth = async (storesList) => {
    if (!storesList.length) return;
    const initialStatus = {};
    storesList.forEach(store => initialStatus[store.id] = 'checking');
  };


  const goNextPage = (ipAddress) => {
    navigate("/shop-details?ip=" + ipAddress)
  }



  return (
    <div className='my-shop-search'>
      <Header style={headerStyle}>
        <div className='header-container'>
          <div className='header-button'></div>
          <div>我的店铺</div>
          <div className='header-button' onClick={handleBack}>返回</div>
        </div>
      </Header>
      <Space direction="vertical" style={contentStyle} size={"large"}>




        <Title level={4}>商品信息查询 (编码: {code})</Title>

        {stores?.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '50px' }}>暂无店铺数据</div>
        ) : (
          <List
            grid={{ gutter: 16, column: 1, xs: 1, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }}
            dataSource={stores || []}
            renderItem={store => {
              const item = productData[store.store_id] || {};
              const productInfo = item?.data; // 获取嵌套的data对象
              return (
                <List.Item>
                  <Card title={`店铺: ${item.storeName || store.store_name}`} bordered={true}>
                    {item.loading ? (
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                        <Spin size="small" tip="加载中..." />
                      </div>
                    ) : item.error ? (
                      <div style={{ color: '#f5222d', padding: '20px', textAlign: 'center' }}>
                        {item.error.status === 404 ? '商品不存在' : '店铺休息中'}
                      </div>
                    ) : productInfo ? (
                      <div style={{ padding: '10px' }}>
                        <p><strong>名称:</strong> {productInfo.NombreES || '--'}</p>
                        <p><strong>售价:</strong> ¥{formatNumber(productInfo.PrecioDetalle)}</p>
                        <p><strong>编码:</strong> {productInfo.ArticuloID || '--'}</p>
                        <p><strong>条码:</strong> {productInfo.CodigoBarra || '--'}</p>
                        <p><strong>库存:</strong> {formatNumber(productInfo.StockDa)} 件</p>
                        <p><strong>进货价:</strong> ¥{formatNumber(productInfo.PrecioCoste)}</p>
                      </div>
                    ) : (
                      <div style={{ padding: '20px', textAlign: 'center' }}>
                商品不存在
              </div>
                    )}
                  </Card>
                </List.Item>
              );
            }}
          />
        )}


      </Space>
    </div>
  );
};


export default MyShopTwo;
